var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16097 14.3171H20.2201C20.5934 14.3171 20.9356 14.1092 21.1076 13.7779L24.5691 7.11127C24.9148 6.44559 24.4317 5.65045 23.6816 5.65045H7.32764",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6611,
    cy: 20.1,
    r: 1.5,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6602,
    cy: 20.1,
    r: 1.5,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1.09998H4.60465C5.20155 1.09998 6.21795 1.59035 6.55814 3.36664C6.88372 5.06664 8.34884 12.6852 9.16279 16.2111C9.32558 16.8407 10.0744 18.1 11.7674 18.1C13.4605 18.1 17.2946 18.1 18 18.1",
    stroke: "#D91F05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActive);
export default __webpack_public_path__ + "static/media/salesActive.6250f26e33b5cafc74a50ac1a7824bbb.svg";
export { ForwardRef as ReactComponent };